import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "video-wall__container" }
const _hoisted_2 = { class: "video-wall__loading" }
const _hoisted_3 = {
  key: 1,
  class: "video-wall-camera-list-group"
}
const _hoisted_4 = { class: "video-wall-camera-list-group__cameras" }
const _hoisted_5 = { class: "video-wall__loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoWallEpisodeList = _resolveComponent("VideoWallEpisodeList")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_VideoWallPresetSaver = _resolveComponent("VideoWallPresetSaver")!
  const _component_VideoWallPresetEditor = _resolveComponent("VideoWallPresetEditor")!
  const _component_VideoWallLayoutSelect = _resolveComponent("VideoWallLayoutSelect")!
  const _component_VideoWallPageSidebarSection = _resolveComponent("VideoWallPageSidebarSection")!
  const _component_VideoWallPresetSelect = _resolveComponent("VideoWallPresetSelect")!
  const _component_NInput = _resolveComponent("NInput")!
  const _component_VideoWallCameraList = _resolveComponent("VideoWallCameraList")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_VideoWallCameraListGroupItem = _resolveComponent("VideoWallCameraListGroupItem")!
  const _component_VideoWallPageSidebar = _resolveComponent("VideoWallPageSidebar")!
  const _component_AsyncComponentWrapper = _resolveComponent("AsyncComponentWrapper")!
  const _component_VideoWall = _resolveComponent("VideoWall")!
  const _component_VideoWallPageLayout = _resolveComponent("VideoWallPageLayout")!

  return (_openBlock(), _createBlock(_component_VideoWallPageLayout, {
    "layout-state": _ctx.state.layout,
    ref: "layout"
  }, {
    episodes: _withCtx(() => [
      (_ctx.areEpisodesVisible)
        ? (_openBlock(), _createBlock(_component_VideoWallEpisodeList, {
            key: 0,
            tab: _ctx.tab,
            "camera-ids": _ctx.enabledCameraIds
          }, null, 8, ["tab", "camera-ids"]))
        : _createCommentVNode("", true)
    ]),
    "fullscreen-activator": _withCtx(() => [
      _createVNode(_component_NButton, {
        onClick: _ctx.requestFullScreen,
        icon: "fullscreen",
        type: "secondary"
      }, null, 8, ["onClick"])
    ]),
    "preset-editor": _withCtx(() => [
      (_ctx.hasVideoWallPresetBeenModified)
        ? (_openBlock(), _createBlock(_component_VideoWallPresetSaver, {
            key: _ctx.preset.id,
            name: '',
            onSave: _ctx.handleVideoWallPresetSaveEvent
          }, null, 8, ["onSave"]))
        : (_openBlock(), _createBlock(_component_VideoWallPresetEditor, {
            key: 'editor-' + _ctx.preset.id,
            name: _ctx.preset.name,
            onSave: _ctx.handleVideoWallPresetSaveEvent
          }, null, 8, ["name", "onSave"]))
    ]),
    "sidebar-activator": _withCtx(() => [
      _createVNode(_component_NButton, {
        onClick: _ctx.handleSidebarToggle,
        icon: "configure",
        type: "secondary"
      }, null, 8, ["onClick"])
    ]),
    sidebar: _withCtx(() => [
      _createVNode(_component_VideoWallPageSidebar, { onClose: _ctx.handleSidebarToggle }, {
        default: _withCtx(() => [
          _createVNode(_component_VideoWallPageSidebarSection, {
            header: _ctx.$t('videowall.general_layouts')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VideoWallLayoutSelect, { onClick: _ctx.handleVideoWallLayoutChange }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          (_ctx.arePresetsSectionVisible)
            ? (_openBlock(), _createBlock(_component_VideoWallPageSidebarSection, {
                key: 0,
                header: _ctx.$t('videowall.saved_presets')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VideoWallPresetSelect, {
                    presets: _ctx.presetsModule.presets,
                    onDelete: _ctx.handleVideoWallPresetDeleteEvent,
                    onSelect: _ctx.handleVideoWallPresetSelectEvent
                  }, null, 8, ["presets", "onDelete", "onSelect"])
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_VideoWallPageSidebarSection, {
            header: _ctx.$t('videowall.cameras'),
            style: {"overflow":"auto","flex":"1 1"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NInput, {
                modelValue: _ctx.cameraGroupsModule.filter.current.name_contains,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cameraGroupsModule.filter.current.name_contains) = $event)),
                clearable: "",
                placeholder: _ctx.$t('common.camera_groups', 'f'),
                label: _ctx.$t('common.camera_groups', 'f')
              }, null, 8, ["modelValue", "placeholder", "label"]),
              _createVNode(_component_NInput, {
                modelValue: _ctx.camerasModule.filter.current.name_contains,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.camerasModule.filter.current.name_contains) = $event)),
                clearable: "",
                placeholder: _ctx.$t('common.cameras', 'f'),
                label: _ctx.$t('common.cameras', 'f')
              }, null, 8, ["modelValue", "placeholder", "label"]),
              _createElementVNode("div", _hoisted_1, [
                (!_ctx.camerasModule.filter.current.name_contains)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_VideoWallCameraList, { groups: _ctx.cameraGroups }, null, 8, ["groups"]),
                      _createElementVNode("div", _hoisted_2, [
                        (_ctx.cameraGroupsModule.loading || _ctx.cameraGroupsModule.appending)
                          ? (_openBlock(), _createBlock(_component_NLoadingCircle, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_InfiniteScroll, {
                        filters: _ctx.cameraGroupsModule.filter.current,
                        onLoadMore: _cache[2] || (_cache[2] = () => _ctx.cameraGroupsModule.append())
                      }, null, 8, ["filters"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.camerasModule.items, (camera) => {
                          return (_openBlock(), _createBlock(_component_VideoWallCameraListGroupItem, {
                            key: camera.id,
                            camera: camera
                          }, null, 8, ["camera"]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.camerasModule.loading || _ctx.camerasModule.appending)
                          ? (_openBlock(), _createBlock(_component_NLoadingCircle, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_InfiniteScroll, {
                        filters: _ctx.camerasModule.filter.current,
                        onLoadMore: _cache[3] || (_cache[3] = () => _ctx.camerasModule.append())
                      }, null, 8, ["filters"])
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    "video-wall": _withCtx(() => [
      _createVNode(_component_VideoWall, {
        ref: "wall",
        "camera-ids": _ctx.preset.cameraIds,
        "onUpdate:camera-ids": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.preset.cameraIds) = $event))
      }, {
        camera: _withCtx(({ id }) => [
          (_openBlock(), _createBlock(_component_AsyncComponentWrapper, {
            key: id,
            component: _ctx.VideoWallPlayer,
            promise: _ctx.getCameraById(id),
            "promise-target-property": 'camera',
            "loading-error": _ctx.$t('videowall.loading_error')
          }, null, 8, ["component", "promise", "loading-error"]))
        ]),
        _: 1
      }, 8, ["camera-ids"])
    ]),
    _: 1
  }, 8, ["layout-state"]))
}